import { GoBackend } from "../../config.js";

export function IsGoBackEnd() {
    return GoBackend === true;
}
